import { Component, OnInit, Input, OnChanges, SimpleChanges, ViewEncapsulation } from "@angular/core";
import { GraphicType } from "./schema/graphic-type";
import { GraphicData } from "./schema/graphic-data";
import { GraphicGroup } from "./schema/graphic-group";

@Component({
    selector: "app-graphic-report",
    templateUrl: "./graphic-report.component.html",
    styleUrls: ["./graphic-report.component.scss"]
})
export class GraphicReportComponent implements OnInit, OnChanges {
    //Título do card de gráfico
    @Input("title")
    private _title: string;
    //Subtítulo do card de gráfico
    @Input("subtitle")
    private _subtitle: string;
    //Tipo de gráfico: GraphicType
    @Input("type")
    private _type: GraphicType;

    //Dados que serão computados para a exibição
    @Input("data")
    private _data: any[];
    //Propriedades do objeto do array [data] que servirão grupos de informação
    @Input("data_group")
    private _dataGroup: string;
    //Propriedades do objeto do array [data] que servirão linhas de informação
    @Input("data_name")
    private _dataName: string;
    //Propriedades do objeto do array [data] que servirão de valores
    @Input("data_value")
    private _dataValue: string;
    //Se deve somar os valores encontrados do objeto do array com [data_value] ou se deve contar quantos elementos o array possui na condição
    @Input("data_sum")
    private _dataSum: boolean;
    //Se deve exportar os dados do gráfico (api irá gerar o csv e enviar por email para o usuário logado)
    @Input("export_data")
    public exportData: boolean;

    public title: string;
    public subtitle: string;
    public type: GraphicType;
    public data: GraphicData;

    public bar: GraphicType = GraphicType.Bar;
    public doughnut: GraphicType = GraphicType.Doughnut;
    public line: GraphicType = GraphicType.Line;
    public pie: GraphicType = GraphicType.Pie;
    public none: GraphicType = GraphicType.None;

    constructor() {
        this.title = "";
        this._title = "";

        this.subtitle = "";
        this._subtitle = "";

        this.type = GraphicType.None;
        this._type = GraphicType.None;

        this.data = {
            keys: [],
            group: []
        };

        this._data = [];

        this._dataGroup = "group";
        this._dataName = "key";
        this._dataValue = "value";
        this._dataSum = false;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes._title && changes._title.currentValue != this.title) {
            this.title = changes._title.currentValue;
        }
        if (changes._subtitle && changes._subtitle.currentValue != this.title) {
            this.subtitle = changes._subtitle.currentValue;
        }
        if (changes._type && changes._type.currentValue != this.type) {
            this.type = changes._type.currentValue;
        }
        if (
            (changes._data && JSON.stringify(changes._data.currentValue) != JSON.stringify(this.data)) ||
            (changes._dataGroup && changes._dataGroup.previousValue != changes._dataGroup.currentValue) ||
            (changes._dataName && changes._dataName.previousValue != changes._dataName.currentValue) ||
            (changes._dataValue && changes._dataValue.previousValue != changes._dataValue.currentValue) ||
            (changes._sum && changes._sum.previousValue != changes._sum.currentValue)
        ) {
            this.data = this.manageData(changes._data.currentValue);
        }
    }

    ngOnInit() {
        this.title = this._title;
        this.subtitle = this._subtitle;
        this.data = this.manageData(this._data);
        this.type = this._type;
    }

    private manageData(data: any[]): GraphicData {
        if (data.length <= 0) {
            return {
                keys: [],
                group: []
            } as GraphicData;
        }

        const result: GraphicGroup[] = [];
        const keys: string[] = [];
        const groups: string[] = [];

        groups.push(...new Set(data.map((item) => item[this._dataGroup]).filter((item) => item != undefined)));
        keys.push(...new Set(data.map((item) => item[this._dataName]).filter((item) => item != undefined)));

        if (keys.length <= 0) keys.push(this._dataName);

        groups.forEach((group) => {
            const values: number[] = [];
            keys.forEach((key) => {
                const items = data.filter(
                    (item) =>
                        item[this._dataGroup] == group &&
                        (item[this._dataName] == undefined || item[this._dataName] == key)
                );

                if (items.length <= 0) {
                    values.push(0);
                } else {
                    if (typeof items[0][this._dataValue] == "number") {
                        if (!this._dataSum) values.push(items.length);
                        else values.push(items.reduce((sum, item) => sum + item[this._dataValue], 0));
                    } else {
                        values.push(items.length);
                    }
                }
            });

            result.push({
                group: group,
                values: values
            });
        });

        return {
            keys: keys,
            group: result
        } as GraphicData;
    }
}
